var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "box-processo", attrs: { shadow: "hover" } },
    [
      _c("h1", [_vm._v("Atualizar Processo")]),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "label",
            { staticClass: "labelSelect" },
            [
              _vm._v("Cadastro:"),
              _c(
                "el-select",
                {
                  staticClass: "selectStatus",
                  attrs: {
                    placeholder: "Selecione o(s) cadastro(s)",
                    multiple: "multiple",
                    "collapse-tags": "collapse-tags",
                    "collapse-tags-tooltip": "collapse-tags-tooltip",
                    filterable: "filterable"
                  },
                  model: {
                    value: _vm.tiposCadastroSelecionados,
                    callback: function($$v) {
                      _vm.tiposCadastroSelecionados = $$v
                    },
                    expression: "tiposCadastroSelecionados"
                  }
                },
                _vm._l(_vm.tiposCadastro, function(cadastro) {
                  return _c("el-option", {
                    key: cadastro,
                    attrs: { label: cadastro, value: cadastro }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "label",
            { staticClass: "labelSelect" },
            [
              _vm._v("Setor:"),
              _c(
                "el-select",
                {
                  staticClass: "selectStatus",
                  attrs: {
                    placeholder: "Selecione o(s) setores(s)",
                    multiple: "multiple",
                    "collapse-tags": "collapse-tags",
                    "collapse-tags-tooltip": "collapse-tags-tooltip",
                    filterable: "filterable"
                  },
                  model: {
                    value: _vm.setoresSelecionados,
                    callback: function($$v) {
                      _vm.setoresSelecionados = $$v
                    },
                    expression: "setoresSelecionados"
                  }
                },
                _vm._l(_vm.setores, function(setor) {
                  return _c("el-option", {
                    key: setor,
                    attrs: { label: setor, value: setor }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "label",
            { staticClass: "labelSelect" },
            [
              _vm._v("Status:"),
              _c(
                "el-select",
                {
                  staticClass: "selectStatus",
                  attrs: {
                    placeholder: "Selecione o(s) status",
                    multiple: "multiple",
                    "collapse-tags": "collapse-tags",
                    "collapse-tags-tooltip": "collapse-tags-tooltip",
                    filterable: "filterable"
                  },
                  model: {
                    value: _vm.statusSelecionados,
                    callback: function($$v) {
                      _vm.statusSelecionados = $$v
                    },
                    expression: "statusSelecionados"
                  }
                },
                _vm._l(_vm.status, function(s) {
                  return _c("el-option", {
                    key: s.codigo,
                    attrs: { label: s.nome, value: s.codigo }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c("el-checkbox", {
            attrs: { label: "Atualizar Sub Processo" },
            model: {
              value: _vm.atualizaSubProcesso,
              callback: function($$v) {
                _vm.atualizaSubProcesso = $$v
              },
              expression: "atualizaSubProcesso"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "containerBotao" },
        [
          _c("el-button", { staticClass: "botao", on: { click: _vm.enviar } }, [
            _vm._v("enviar")
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-498ad153", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-498ad153","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/AtualizarProcessos.vue
// module id = null
// module chunks = 